<div class="d-lg-block" style="" data-aos="fade-up" data-aos-duration="1200">
    <ul class="nav flex-column justify-content-between pb-lg-1 mb-lg-3">
        <li *ngFor="let item of ImportantLinks" class="nav-item w-xl-75 w-100">
            <a href="{{item.url}}" class="nav-link d-inline-block px-0 pt-1 pb-2 w-100 fs-sm">{{item.title}}</a>
        </li>
    </ul>
</div>